module.exports = __webpack_public_path__ + "static/media/bg.8efaf70c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bg.png
// module id = 715
// module chunks = 0